import styled from "@emotion/styled";

export const SpanNewTag = styled.span`
  // MEMO: DMM全体で使用しているサービスメニューの赤色
  color: #dc0000;
  font-size: 10px;
  margin-left: 4px;
  border: 1px solid #dc0000;
  border-radius: 8px;
  padding: 0px 4px;
`;
